import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/portfolio/sales/revenue";

const StoreHistoricSalesTrend = () => {
    const storeHistoricSalesTrend = useSelector(state => selectors.storeHistoricSalesTrend(state));
    const { loading, error, id, label, status, value } = storeHistoricSalesTrend;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default StoreHistoricSalesTrend;
